<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-avatar
        v-on="on"
      >
        <v-icon
          class="evidence"
          :color="color"
        >
          mdi-help-circle-outline
        </v-icon>
      </v-avatar>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title">Evidência(s) Válida(s)</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row
          class="text-center"
        >
          <v-col>
            <h2>{{ evidence }}</h2>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'AppModalShowEvidence',
  props: {
    evidence: { type: String },
    color: { type: String }
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
